import { observable } from "mobx";
import moment from 'moment';
const data = {
    nowYear: moment().format("YYYY"),//当前年
    selectedDate: moment(),//当前时间
    selectedAcademyStuType:"0",//0本专科生  1研究生
    postgraduateAcademy: [],
    undergraduateAcademy: [],
    province: [],
    selectedTimeSlotStuType:"0",//0本专科生 1 研究生
    postgraduateTimeSlot: [],
    undergraduateTimeSlot: [],
    selectedTopStuType:"0",//0本专科生 1 研究生
    postgraduateTop: [],
    undergraduateTop: [],
    wholeStatistics: [],
    allShouldArrive:0,
    allArrived:0,
    international:{}
};

export default observable(data);